<template>
  <div class="dashboard" :style="{ backgroundImage: `url(/backimag1.png)` }">
    <div class="grid-container">
      <!-- 第1行：高度比例 1 -->
      <div class="grid-item header" style="grid-column: 1 / 4; background: none; border: none;">
        <div class="header-content">
          <!-- 标题居中 -->
          <p class="title">进销存平台-销售</p>

          <!-- 最右边图标区域 -->
          <div class="header-icons">
            <button class="icon-btn" title="返回系统">
              <i class="el-icon-refresh-left"  @click="handleBack" ></i>
            </button>
            <button class="icon-btn"  @click="openDialog" title="返回大屏">
              <i class="el-icon-data-analysis"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- 第2行：高度比例 3 -->
      <div class="grid-item" id="mychartA"
      ></div>
      <div class="grid-item main" style="grid-row: span 2;" id="mychartB">主要内容区 / 大图表 (中)</div>
      <div class="grid-item" style="grid-row: span 2;" id="mychartC">区域 C (右)</div>

      <!-- 第3行：高度比例 3 -->
      <div class="grid-item" id="mychartF">区域 F</div>

      <!-- 第4行：高度比例 3 -->
      <div class="grid-item" id="mychartG"></div>
      <div class="grid-item" id="mychartH">区域 H</div>
      <div class="grid-item" id="mychartI">区域 I / 底部状态</div>
    </div>

    <!-- Dialog（切换弹窗） -->
    <div v-if="showDialog" class="dialog-overlay" @click="closeDialog">
      <div class="dialog-content" @click.stop>
        <h3>切换销售以及盈利大屏</h3>
        <input type="password" />
        <div class="dialog-actions">
          <button @click="closeDialog">取消</button>
          <button @click="closeDialog">确认切换</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import * as echarts from "echarts";
import chinaGeoJson from '@/views/showbig/map.json'
export default {
  data() {
    return {
      showDialog: false,
      mychartsA: [],
      mychartsB: [],
      mychartsC: [],
      mychartsD: [],
      mychartsF: [],
      mychartsG: [],
      mychartsH: [],
      mychartsI: [],
    }
  },
  mounted() {
    this.getList();
    this.initEchartsH();
    this.initEchartsC();
    this.initEchartsG();
    this.initEchartsI();
    this.initEchartsA();
    this.initEchartsF();
    this.initEchartsB();

  },

  methods: {
    initEchartsH() {// SVG 相关代码保持不变
      let titlename='怀柔仓库-出入库价值金额';
      let option = {
        grid: {
          left: "5%",
          right: "5%",
          top: "20%",
          bottom: "5%",
          containLabel: true,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: 'shadow'
          },
          formatter: function(params) {
            let res = params[0].axisValue + '<br/>';
            for (let i = 0; i < params.length; i++) {
              res += params[i].marker + params[i].seriesName + '：' + params[i].value + '元<br/>';
            }
            return res;
          }
        },
        title: {
          text: titlename,           // 标题文本
          left: 'center',             // 水平居中
          top: '2%',                  // 距离顶部距离
          textStyle: {
            color: '#fff',            // 标题颜色
            fontSize: 15,             // 标题字体大小
            fontWeight: 'bold',       // 字体加粗
          },
        },

        legend: {
          itemWidth: 10,
          itemHeight: 10,
          itemGap: 30,
          left: '40%',
          top: '10%',
          textStyle: {
            color: '#c6d1db'
          }
        },
        // Y轴配置 - 使用对数轴实现指数级显示
        yAxis: {
          type: "log",               // 使用对数轴
          name: "金额（元）",
          nameTextStyle: {
            color: '#c6d1db',
            fontSize: 14,
            fontWeight: 'bold'
          },
          show: true,
          // 对数轴特殊配置
          logBase: 10,                // 以10为底的对数
          axisLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255,255,255,0.2)'
            }
          },
          axisTick: {
            show: true,
            lineStyle: {
              color: 'rgba(255,255,255,0.2)'
            }
          },
          axisLabel: {
            show: true,
            color: '#c6d1db',
            fontSize: 12,
            formatter: function(value) {
              if (value >= 10000) {
                return (value/10000).toFixed(0) + '万';
              } else if (value >= 1000) {
                return (value/1000).toFixed(0) + '千';
              } else {
                return value;
              }
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255,255,255,0.1)',
              type: 'dashed'
            }
          },
          // 设置最小值，避免出现0（对数轴不能有0）
          min: 1,
          // 设置间隔，让显示更清晰
          splitNumber: 8
        },
        // X轴配置
        xAxis: {
          type: "category",
          data: ['一月', '二月', '三月', '四月', '五月', '六月', '七月'],
          axisTick: {
            show: true,
            lineStyle: {
              color: 'rgba(255,255,255,0.2)'
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255,255,255,0.2)'
            }
          },
          axisLabel: {
            show: true,
            fontSize: 14,
            color: '#c6d1db',
            fontWeight: 'bold'
          },
        },
        series: [
          {
            name: '销',
            type: "bar",
            barGap: '30%',
            barWidth: '30%',
            data: [10, 100, 1000, 10000, 50000, 100000, 500000],
            itemStyle: {
              color: {
                type: 'linear',
                x: 0, y: 0,
                x2: 0, y2: 1,
                colorStops: [
                  { offset: 0, color: '#0d3458' },
                  { offset: 1, color: '#3167ef' }
                ]
              },
              borderWidth: 1,
              borderColor: '#3167ef'
            },
            label: {
              show: true,
              position: 'top',
              color: '#fff',
              formatter: function(params) {
                if (params.value >= 10000) {
                  return (params.value/10000).toFixed(1) + '万';
                } else if (params.value >= 1000) {
                  return (params.value/1000).toFixed(1) + '千';
                } else {
                  return params.value;
                }
              }
            }
          },
          {
            name: '存',
            type: 'bar',
            barGap: '30%',
            barWidth: '30%',
            data: [20, 200, 2000, 20000, 80000, 200000, 800000],
            itemStyle: {
              color: {
                type: 'linear',
                x: 0, y: 1,
                x2: 0, y2: 0,
                colorStops: [
                  { offset: 0, color: '#656538' },
                  { offset: 1, color: '#f8e71c' }
                ]
              },
              borderWidth: 1,
              borderColor: '#f8e71c'
            },
            label: {
              show: true,
              position: 'top',
              color: '#fff',
              formatter: function(params) {
                if (params.value >= 10000) {
                  return (params.value/10000).toFixed(1) + '万';
                } else if (params.value >= 1000) {
                  return (params.value/1000).toFixed(1) + '千';
                } else {
                  return params.value;
                }
              }
            }
          }
        ]
      };


// 初始化图表
      const echartsdom = document.getElementById('mychartH')
      this.mychartsH = echarts.init(echartsdom)

      this.mychartsH.setOption(option, true);// 渲染页面
    },
    initEchartsG: function () {// SVG 相关代码保持不变
       var trafficWay = [
        {
          name: "d部",
          amount: 2000  // 直接使用金额
        },
        {
          name: "x部",
          amount: 1500
        },
        {
          name: "z部",
          amount: 2400
        },
        {
          name: "n部",
          amount: 3200
        },
        {
          name: "b部",
          amount: 1200
        },
      ];

// 计算总金额
      var totalAmount = 0;
      for (var i = 0; i < trafficWay.length; i++) {
        totalAmount += trafficWay[i].amount;
      }

      var data = [];
      var color = [
        "#00ffff",
        "#00cfff",
        "#006ced",
        "#ffe000",
        "#ffa800",
        "#ff5b00",
        "#ff3000",
      ];

      for (var i = 0; i < trafficWay.length; i++) {
        data.push(
            {
              value: trafficWay[i].amount,  // value改为金额
              name: trafficWay[i].name,
              itemStyle: {
                normal: {
                  borderWidth: 5,
                  shadowBlur: 20,
                  borderColor: color[i],
                  shadowColor: color[i],
                },
              },
            },
            {
              value: 2,
              name: "",
              itemStyle: {
                normal: {
                  label: {
                    show: false,
                  },
                  labelLine: {
                    show: false,
                  },
                  color: "rgba(0, 0, 0, 0)",
                  borderColor: "rgba(0, 0, 0, 0)",
                  borderWidth: 0,
                },
              },
            }
        );
      }

      var seriesOption = [
        {
          name: "",
          type: "pie",
          clockWise: false,
          radius: ['35%', '40%'],
          hoverAnimation: false,
          itemStyle: {
            normal: {
              label: {
                show: true,
                position: "outside",
                color: "#ddd",
                formatter: function (params) {
                  if (params.name !== "") {
                    // 找到对应的交通方式数据
                    var wayData = trafficWay.find(function (item) {
                      return item.name === params.name;
                    });

                    if (wayData) {
                      var percent = ((wayData.amount / totalAmount) * 100).toFixed(2);
                      // 移除末尾多余的0和小数点
                      percent = parseFloat(percent).toString();

                      var amount = wayData.amount.toFixed(2);
                      amount = parseFloat(amount).toString();

                      return (
                          "所属：" + wayData.name + "\n" +
                          "金额：" + amount + "元" + "\n" +
                          "占比：" + percent + "%"
                      );
                    } else {
                      return "";
                    }
                  } else {
                    return "";
                  }
                },
                fontSize: 12,
                lineHeight: 20,
              },
              labelLine: {
                length: 15,
                length2: 35,
                show: true,
                color: "#00ffff",
              },
            },
          },
          data: data,
        },
      ];

      let option = {
        color: color,
        title: {
          text: "112",
          top: "45%",
          textAlign: "center",
          left: "49%",
          textStyle: {
            color: "#fff",
            fontSize: 22,
            fontWeight: "400",
          },
        },
        graphic: {
          elements: [
            {
              type: "image",
              z: 3,
              style: {
                width: 178,
                height: 178,
              },
              left: "center",
              top: "center",
              position: [100, 100],
            },
          ],
        },
        tooltip: {
          show: false,
        },
        legend: {
          icon: "circle",
          orient: "horizontal",
          data: ["d部", "x部", "z部", "n部", "b部"],
          // 修改：图例放在底部居中
          bottom: 10,  // 距离底部10px
          left: "center",  // 水平居中
          align: "center",  // 文字居中对齐
          textStyle: {
            color: "#fff",
          },
          itemGap: 20,

        },
        toolbox: {
          show: false,
        },
        series: seriesOption,
      };

// 添加自适应配置
// 让图表容器宽度设为100%，高度根据需要设置
// 在HTML中设置div样式：
// <div id="chart" style="width: 100%; height: 400px;"></div>


// 初始化图表
      const echartsdom = document.getElementById('mychartG')
      this.mychartsG = echarts.init(echartsdom)

      this.mychartsG.setOption(option, true);// 渲染页面
    },
    initEchartsC() {
      var myData = [
        "xx公司",
        "xx1公司",
        "xx2公司",
        "xx3公司",
        "xx4公司",
        "xx5公司",
        "xx6公司",
        "xx7公司",
        "xx8公司",
        "xx9公司",
        "xx10公司",
        "xx11公司",
        "xx12公司",
        "xx13公司",
        "xx14公司",
        "xx15公司",
      ];
      var databeast = {
        1: [
          389, 259, 262, 324, 232, 176, 196, 214, 133, 370, 268, 360, 185, 392, 392,
          153,
        ],
        2: [
          111, 315, 139, 375, 204, 352, 163, 258, 385, 209, 209, 243, 204, 352, 163,
          258,
        ],
        3: [
          227, 210, 328, 292, 241, 110, 130, 185, 392, 392, 153, 187, 150, 200, 250,
          300,
        ],
        4: [
          100, 350, 300, 250, 200, 150, 100, 150, 200, 250, 300, 350, 400, 350, 300,
          250,
        ],
        5: [
          280, 128, 255, 254, 313, 143, 360, 343, 338, 163, 333, 317, 263, 302, 372,
          163,
        ],
        6: [
          121, 388, 233, 309, 133, 308, 297, 283, 349, 273, 229, 238, 224, 291, 185,
          203,
        ],
        7: [
          200, 350, 300, 250, 200, 150, 100, 150, 200, 250, 300, 350, 400, 350, 300,
          250,
        ],
        8: [
          380, 129, 173, 101, 310, 393, 386, 296, 366, 268, 208, 149, 356, 239, 208,
          330,
        ],
        9: [
          363, 396, 388, 108, 325, 120, 180, 292, 200, 309, 223, 236, 209, 271, 215,
          216,
        ],
        10: [
          300, 350, 300, 250, 200, 150, 100, 150, 200, 250, 300, 350, 400, 350, 300,
          250,
        ],
        11: [
          100, 350, 300, 250, 200, 150, 100, 150, 200, 250, 300, 350, 400, 350, 300,
          250,
        ],
        12: [
          280, 128, 255, 254, 313, 143, 360, 343, 338, 163, 333, 317, 263, 302, 372,
          163,
        ],
      };
      var databeauty = {
        1: [
          121, 388, 233, 309, 133, 308, 297, 283, 349, 273, 229, 238, 224, 291, 185,
          203,
        ],
        2: [
          200, 350, 300, 250, 200, 150, 100, 150, 200, 250, 300, 350, 400, 350, 300,
          250,
        ],
        3: [
          380, 129, 173, 101, 310, 393, 386, 296, 366, 268, 208, 149, 356, 239, 208,
          330,
        ],
        4: [
          363, 396, 388, 108, 325, 120, 180, 292, 200, 309, 223, 236, 209, 271, 215,
          216,
        ],
        5: [
          300, 350, 300, 250, 200, 150, 100, 150, 200, 250, 300, 350, 400, 350, 300,
          250,
        ],
        6: [
          100, 350, 300, 250, 200, 150, 100, 150, 200, 250, 300, 350, 400, 350, 300,
          250,
        ],
        7: [
          280, 128, 255, 254, 313, 143, 360, 343, 338, 163, 333, 317, 263, 302, 372,
          163,
        ],
        8: [
          389, 259, 262, 324, 232, 176, 196, 214, 133, 370, 268, 360, 185, 392, 392,
          153,
        ],
        9: [
          111, 315, 139, 375, 204, 352, 163, 258, 385, 209, 209, 243, 204, 352, 163,
          258,
        ],
        10: [
          227, 210, 328, 292, 241, 110, 130, 185, 392, 392, 153, 187, 150, 200, 250,
          300,
        ],
        11: [
          100, 350, 300, 250, 200, 150, 100, 150, 200, 250, 300, 350, 400, 350, 300,
          250,
        ],
        12: [
          280, 128, 255, 254, 313, 143, 360, 343, 338, 163, 333, 317, 263, 302, 372,
          163,
        ],
      };
      var timeLineData = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

     let option = {
        baseOption: {
          timeline: {
            show: true,
            axisType: "category",
            tooltip: {
              show: true,
              formatter: function (params) {
                console.log(params);
                return params.name + "月份数据统计";
              },
            },
            autoPlay: true,
            currentIndex: 6,
            playInterval: 5000,
            label: {
              normal: {
                show: true,
                interval: "auto",
                formatter: "{value}月",
              },
            },
            data: [],
          },
          title: {
            textStyle: {
              color: "#ffffff",  // 标题颜色改为深色以适应白色背景
              fontSize: 16,
            },
          },
          legend: {
            data: ["回款", "未回款"],
            top: 4,
            right: "20%",
            textStyle: {
              color: "#ffffff",  // 图例文字颜色改为深色
            },
          },
          tooltip: {
            show: true,
            trigger: "axis",
            formatter: "{b}<br/>{a}: {c}元",
            axisPointer: {
              type: "shadow",
            },
          },

          toolbox: {
            right: 20,
            feature: {
              /*saveAsImage: {},
              restore: {},*/
              // dataView: {},
              // 2. 去掉不需要的功能
              // dataZoom: {},
              magicType: {
                type: ["line", "bar"],
              },
            },
          },

          grid: [
            {
              show: false,
              left: "8%",
              top: 60,
              bottom: 60,
              containLabel: true,
              width: "46%",
            },
            {
              show: false,
              left: "50.5%",
              top: 80,
              bottom: 60,
              width: "0%",
            },
            {
              show: false,
              right: "0%",
              left: "54%",
              top: 60,
              bottom: 60,
              containLabel: true,
              width: "40%",
            },
          ],

          xAxis: [
            {
              type: "value",
              inverse: true,
              axisLine: {
                show: false,
              },
              axisTick: {
                show: false,
              },
              position: "top",
              axisLabel: {
                show: true,
                textStyle: {
                  color: "#E0E0E0",  // 轴标签颜色调深
                  fontSize: 12,
                },
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: "#E0E0E0",  // 分割线颜色调浅
                  width: 1,
                  type: "solid",
                },
              },
            },
            {
              gridIndex: 1,
              show: false,
            },
            {
              gridIndex: 2,
              type: "value",
              axisLine: {
                show: false,
              },
              axisTick: {
                show: false,
              },
              position: "top",
              axisLabel: {
                show: true,
                textStyle: {
                  color: "#E0E0E0",  // 轴标签颜色调深
                  fontSize: 12,
                },
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: "#E0E0E0",  // 分割线颜色调浅
                  width: 1,
                  type: "solid",
                },
              },
            },
          ],
          yAxis: [
            {
              type: "category",
              inverse: true,
              position: "right",
              axisLine: {
                show: false,
              },
              axisTick: {
                show: false,
              },
              axisLabel: {
                show: true,  // 3. 显示公司名称（右侧）
                margin: 8,
                textStyle: {
                  color: "#ffffff",  // 文字颜色加深
                  fontSize: 12,
                },
              },
              data: myData,
            },
            {
              gridIndex: 1,
              type: "category",
              inverse: true,
              position: "left",
              axisLine: {
                show: false,
              },
              axisTick: {
                show: false,
              },
              axisLabel: {
                show: false,  // 关闭左侧标签避免重叠
                textStyle: {
                  color: "#fffff",
                  fontSize: 12,
                },
              },
              data: myData.map(function (value) {
                return {
                  value: value,
                  textStyle: {
                    align: "center",
                  },
                };
              }),
            },
            {
              gridIndex: 2,
              type: "category",
              inverse: true,
              position: "left",
              axisLine: {
                show: false,
              },
              axisTick: {
                show: false,
              },
              axisLabel: {
                show: false,
                textStyle: {
                  color: "#ffffff",
                  fontSize: 12,
                },
              },
              data: myData,
            },
          ],
          series: [],
        },

        options: [],
      };

      for (var i = 0; i < timeLineData.length; i++) {
        option.baseOption.timeline.data.push(timeLineData[i]);
        option.options.push({
          title: {
            text: timeLineData[i] + "月份回款情况",
            textStyle: {
              color: "#ffffff",  // 标题颜色加深
            },
          },
          series: [

            {
              name: "回款",
              type: "bar",
              barGap: 20,
              barWidth: 20,
              xAxisIndex: 2,
              yAxisIndex: 2,
              label: {
                normal: {
                  show: false,
                },
                emphasis: {
                  show: true,
                  position: "left",
                  offset: [0, 0],
                  textStyle: {
                    color: "#fffff",  // 强调标签颜色加深
                    fontSize: 14,
                  },
                },
              },
              itemStyle: {
                normal: {
                  color: "#F68989",
                },
                emphasis: {
                  color: "#F94646",
                },
              },
              data: databeauty[timeLineData[i]],
            },
            {
              name: "未回款",
              type: "bar",
              barGap: 20,
              barWidth: 20,
              label: {
                normal: {
                  show: false,
                },
                emphasis: {
                  show: true,
                  position: "right",
                  offset: [0, 0],
                  textStyle: {
                    color: "#fffff",  // 强调标签颜色加深
                    fontSize: 14,
                  },
                },
              },
              itemStyle: {
                normal: {
                  color: "#659F83",
                },
                emphasis: {
                  color: "#08C7AE",
                },
              },
              data: databeast[timeLineData[i]],
            },

          ],
        });
      }




// 初始化图表
      const echartsdom = document.getElementById('mychartC')
      this.mychartsC = echarts.init(echartsdom)
      this.mychartsC.setOption(option, true);// 渲染页面
    },
    initEchartsI() {
     let option = {
        color: [
          "#FAE927",
          "#E9E416",
          "#C9DA36",
          "#9ECB3C",
          "#6DBC49",
          "#37B44E",
          "#3DBA78",
          "#14ADCF",
          "#209AC9",
          "#1E91CA",
          "#2C6BA0",
          "#2B55A1",
          "#2D3D8E",
          "#44388E",
          "#6A368B",
          "#7D3990",
          "#A63F98",
          "#C31C88",
          "#D52178",
          "#D5225B",
          "#D02C2A",
          "#D44C2D",
          "#F57A34",
          "#FA8F2F",
          "#D99D21",
          "#CF7B25",
          "#CF7B25",
          "#CF7B25",
        ],
        legend: {
          left: "center",
          top: 20,
          itemWidth: 15,        // 图例宽度从25改为15
          itemHeight: 15,       // 图例高度从25改为15
          itemGap: 10,          // 图例间距适当调小
          textStyle: {
            color: "#ffffff",   // 改为纯白色
            fontSize: 11,       // 字体大小稍微调小一点以适应小图例
          },
        },
        calculable: true,
        series: [
          {
            name: "",
            type: "pie",
            startAngle: 0,
            clockwise: false,
            radius: ["30%", "90%"],
            center: ["50%", "65%"],
            roseType: "area",
            avoidLabelOverlap: false,
            label: {
              show: true,
              position: "inside",
              formatter: "{c}元",
              textStyle: {
                fontWeight: "100",
                fontFamily: "Microsoft YaHei",
                color: "#ffffff",    // 改为纯白色
                // fontSize: 8
              },
            },
            itemStyle: {
              normal: {
                borderWidth: 3,
                borderColor: "#19181d",
                shadowColor: "#19181d",
                shadowBlur: 30,
              },
            },
            data: [
              {
                value: 600,
                name: "球机",
              },
              {
                value: 1100,
                name: "半球",
              },
              {
                value: 1200,
                name: "枪机",
              },
              {
                value: 1300,
                name: "59枪机",
              },
              {
                value: 1250,
                name: "59半球",
              },
              {
                value: 400,
                name: "112枪机",
              },
              {
                value: 680,
                name: "一体化平台",
              },
              {
                value: 850,
                name: "ukey",
              },
              {
                value: 470,
                name: "8.0枪机",
              },
            ].sort(function (a, b) {
              return b.value - a.value;
            }),
          },
          {
            type: "pie",
            radius: ["28.5%", "30%"],
            data: [100],
            center: ["50%", "65%"],
            itemStyle: {
              normal: {
                color: "#888",
                shadowColor: "#000",
                shadowBlur: 15,
                shadowOffsetX: "0",
                shadowOffsetY: "0",
              },
            },
            hoverAnimation: false,
            label: {
              show: false,
            },
          },
          {
            type: "pie",
            radius: ["26.5%", "27%"],
            data: [100],
            center: ["50%", "65%"],
            color: "#888",
            hoverAnimation: false,
            label: {
              show: false,
            },
          },
        ],
      };





// 初始化图表
      const echartsdom = document.getElementById('mychartI')
      this.mychartsI = echarts.init(echartsdom)
      this.mychartsI.setOption(option, true);// 渲染页面
    },
    initEchartsA() {
      //	得到仪表盘
      let axisLine = {
        show: false,
        lineStyle: {
          width: 10,
          shadowBlur: 0,
          color: [
            [0.2, "#6ff2c2"],
            [0.4, "#c2fb83"],
            [0.6, "#eadc57"],
            [0.8, "#fab272"],
            [1, "#ff776b"],
          ],
        },
      };
      let textStyle = {
        fontWeight: "normal",
        fontSize: 16,
        color: "#ffffff", // 改为深色以适应白色背景
      };
      let axisLineZhou = {
        // 坐标轴线
        lineStyle: {
          color: [
            [0.66, "#dddddd"],
            [1, "#dddddd"],
          ], // 属性lineStyle控制线条样式
          width: 2,
        },
      };
//仪表盘刻度
      let axisTicks = {
        show: true,
        lineStyle: {
          color: "#1b8586",
          width: 1,
        },
        length: -5,
        splitNumber: 8,
      };
      let splitLines = {
        show: true,
        length: -10,
        lineStyle: {
          color: "#1b8586",
        },
      };
      let zuoBiaoAxisLabel = {
        distance: -15,
        textStyle: {
          color: "#03B7C9",
          fontSize: "8",
        },
      };


// 定义数据
      var totalSales = 1000000000; // 总销售 10亿
      var totalCost = 800000000;   // 总成本 8亿
      var totalProfit = 200000000; // 总利润 2亿

// 计算比例
      var salesRatio = 1000000000 / totalSales; // 10亿/总销售 = 1
      var costRatio =  totalCost/ totalSales;   // 总销售/总成本 = 1.25
      var profitRatio = totalProfit /totalSales ; // 总销售/总利润 = 5

// 设置最大值，让指针能够显示
      var costMax = Math.ceil(costRatio * 1.5);
      var salesMax = Math.ceil(salesRatio * 1.5);
      var profitMax = Math.ceil(profitRatio * 1.5);
     function formatNumberWithCommas(num) {
        // 处理空值、NaN等异常情况
        if (num === null || num === undefined || isNaN(num)) {
          return '0';
        }
        // 使用国际化数字格式化，仅保留千分位，不保留小数
        return new Intl.NumberFormat('en-US').format(Number(num));
      }
     let option = {
        title: [
          {
            x: "19%",
            bottom: "28%",
            text: "总成本",
            textStyle: textStyle,
          },
          {
            x: "44%",
            bottom: "28%",
            text: "总销售",
            textStyle: textStyle,
          },
          {
            x: "69%",
            bottom: "28%",
            text: "总利润",
            textStyle: textStyle,
          },
        ],
        // 去掉底色 - 注释掉或删除这行
        // backgroundColor: "#013954",
        series: [
          // 第一个仪表盘 - 总成本 (左侧)
          {
            type: "gauge",
            center: ["25%", "50%"], // 左侧
            radius: "55%",
            splitNumber: 8,
            min: 0,
            max: costMax,
            endAngle: 45,
            clockwise: true,
            axisLine: {
              show: true,
              lineStyle: {
                width: 2,
                shadowBlur: 0,
                color: [[1, "#1b8586"]],
              },
            },
            axisTick: axisTicks,
            splitLine: splitLines,
            axisLabel: zuoBiaoAxisLabel,
            pointer: {
              show: 0,
            },
            detail: {
              show: false,
            },
            data: [
              {
                name: "",
                value: costRatio,
              },
            ],
          },
          {
            type: "gauge",
            center: ["25%", "50%"],
            radius: "50%",
            min: 0,
            max: costMax,
            endAngle: 45,
            splitNumber: 0,
            axisLine: axisLineZhou,
            axisLabel: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            pointer: {
              show: false,
            },
            detail: {
              show: false,
            },
          },
          {
            name: "总成本",
            type: "gauge",
            endAngle: 45,
            radius: "52%",
            center: ["25%", "50%"],
            min: 0,
            max: costMax,
            axisLine: axisLine,
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            pointer: {
              show: true,
              width: 5,
            },
            detail: {
              show: true,
              offsetCenter: [0, "70%"],
              textStyle: {
                fontSize: 14,
                color: "#ff7705",
                fontWeight: "bold",
              },
              formatter: function(value) {
                return value.toFixed(2)*100 + '%\n\n' +formatNumberWithCommas(totalCost)+'元';
              }
            },
            data: [
              {
                value: costRatio,
              },
            ],
          },

          // 第二个仪表盘 - 总销售 (中间)
          {
            type: "gauge",
            center: ["50%", "50%"], // 中间
            radius: "55%",
            splitNumber: 8,
            min: 0,
            max: salesMax,
            startAngle: 200,
            endAngle: -20,
            clockwise: true,
            axisLine: {
              show: true,
              lineStyle: {
                width: 2,
                shadowBlur: 0,
                color: [[1, "#1b8586"]],
              },
            },
            axisTick: axisTicks,
            splitLine: splitLines,
            axisLabel: zuoBiaoAxisLabel,
            pointer: {
              show: 0,
            },
            detail: {
              show: false,
            },
            data: [
              {
                name: "",
                value: salesRatio,
              },
            ],
          },
          {
            type: "gauge",
            center: ["50%", "50%"],
            radius: "50%",
            min: 0,
            max: salesMax,
            startAngle: 200,
            endAngle: -20,
            splitNumber: 0,
            axisLine: axisLineZhou,
            axisLabel: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            pointer: {
              show: false,
            },
            detail: {
              show: false,
            },
          },
          {
            name: "总销售",
            type: "gauge",
            startAngle: 200,
            endAngle: -20,
            radius: "52%",
            center: ["50%", "50%"],
            min: 0,
            max: salesMax,
            axisLine: axisLine,
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            pointer: {
              show: true,
              width: 5,
            },
            detail: {
              show: true,
              offsetCenter: [0, "70%"],
              textStyle: {
                fontSize: 14,
                color: "#ff7705",
                fontWeight: "bold",
              },
              formatter: function(value) {
                return value.toFixed(2)*100 + '%\n\n' +formatNumberWithCommas(totalSales)+'元';
              }
            },
            data: [
              {
                value: salesRatio,
              },
            ],
          },

          // 第三个仪表盘 - 总利润 (右侧)
          {
            type: "gauge",
            center: ["75%", "50%"], // 右侧
            radius: "55%",
            splitNumber: 8,
            min: 0,
            max: profitMax,
            startAngle: 140,
            endAngle: -45,
            clockwise: true,
            axisLine: {
              show: true,
              lineStyle: {
                width: 2,
                shadowBlur: 0,
                color: [[1, "#1b8586"]],
              },
            },
            axisTick: axisTicks,
            splitLine: splitLines,
            axisLabel: zuoBiaoAxisLabel,
            pointer: {
              show: 0,
            },
            detail: {
              show: false,
            },
            data: [
              {
                name: "",
                value: profitRatio,
              },
            ],
          },
          {
            type: "gauge",
            center: ["75%", "50%"],
            radius: "50%",
            min: 0,
            max: profitMax,
            startAngle: 140,
            endAngle: -45,
            splitNumber: 0,
            axisLine: axisLineZhou,
            axisLabel: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            pointer: {
              show: false,
            },
            detail: {
              show: false,
            },
          },
          {
            name: "总利润",
            type: "gauge",
            startAngle: 140,
            endAngle: -45,
            radius: "52%",
            center: ["75%", "50%"],
            min: 0,
            max: profitMax,
            axisLine: axisLine,
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            pointer: {
              show: true,
              width: 5,
            },
            detail: {
              show: true,
              offsetCenter: [0, "70%"],
              textStyle: {
                fontSize: 14,
                color: "#ff7705",
                fontWeight: "bold",
              },
              formatter: function(value) {
                return value.toFixed(2)*100 + '%\n\n' +formatNumberWithCommas(totalProfit)+'元';
              }
            },
            data: [
              {
                value: profitRatio,
              },
            ],
          },
        ],
      };





// 初始化图表
      const echartsdom = document.getElementById('mychartA')
      this.mychartsA = echarts.init(echartsdom)
      this.mychartsA.setOption(option, true);// 渲染页面
    },
    initEchartsF() {
      //	得到仪表盘

      /**
       * author: bingo
       * email: guobin@ebigdata.org
       * date: 2016-12-21
       * version: V1.0
       * description: 季度GDP总值趋势图，针对需求x轴最右边显示最新的季度，并且显示每年的这个季度，同时要显示和隐藏数据。主要解决了两个问题，第一是echarts默认显示x轴第一个数据，通过设置inverse: true让数据和x轴的反转来实现，第二是数据的显示和隐藏，通过labelTag的值来实现
       */
      var labelTag = true;
      var resultData = {
        times: [
          "2025年11月",
          "2025年12月",
          "2026年1月",
          "2026年2月",
          "2026年3月",
          "2026年4月",

        ],
        totalGDPs: [
          "1742.0",
          "1434.7",
          "2078.5",
          "1859.8",
          "1882.6",
          "1459.6",

        ],
        increaseGDPs: [
          "-7.5",
          "-1.7",
          "31.7",
          "4.4",
          "-8.1",
          "-13.6",

        ],
      };

// 将GDP总值从亿元转换为万元（乘以10000）
      var totalGDPsInTenThousand = resultData.totalGDPs.map(function(value) {
        return (parseFloat(value) * 10000).toString();
      });

      let option = {
        title: [
          {
            text: "季度GDP总值趋势图",
            left: "center",
            textStyle: {
              color: "#ffffff",
              fontSize: 16,
              fontWeight: "bold",
              textShadow: '0 0 10px rgba(0,255,255,0.5)'
            },
          },
          // 移除右上角的单位标题，只保留百分比在右Y轴
        ],
        tooltip: {
          trigger: "axis",
          backgroundColor: 'rgba(0,20,40,0.9)',
          borderColor: '#00aaff',
          borderWidth: 1,
          textStyle: {
            color: '#ffffff',
            fontSize: 12
          },
          formatter: function (params) {
            var gdpValue = (params[0].value / 10000).toFixed(1);
            return (
                '<span style="color:#88ffff">' + params[0].name + '</span>' +
                "<br/>" +
                '<span style="color:#00aaff">●</span> ' + params[0].seriesName +
                ": " +
                '<span style="color:#88ffff;font-weight:bold">' + gdpValue + '万元</span>' +
                "<br/>" +
                '<span style="color:#00ff88">●</span> ' + params[1].seriesName +
                ": " +
                '<span style="color:#88ff88;font-weight:bold">' + params[1].value + '%</span>'
            );
          },
        },
        legend: {
          data: ["GDP总值", "GDP增长率"],
          selectedMode: true,
          bottom: "bottom",
          textStyle: {
            color: "#ffffff",
            fontSize: 12,
            textShadow: '0 0 5px rgba(0,255,255,0.3)'
          },
          // 移除边框相关设置
          itemWidth: 20,
          itemHeight: 10,
          itemGap: 20
        },
        grid: {
          left: '5%',     // 增加左边距
          right: '6%',    // 增加右边距
          bottom: '10%',  // 增加底部边距
          top: '15%',     // 增加顶部边距
          containLabel: true,  // 改为true，确保标签不被裁剪
        },
        xAxis: xAxis(),
        yAxis: [
          {
            type: "value",
            name: "营收总额",
            nameTextStyle: {
              color: "#ffffff",
              fontSize: 12,
              textShadow: '0 0 5px rgba(0,255,255,0.3)'
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "#335577",
                width: 1,
                type: "dashed",
              },
            },
            min: 0,
            interval: 5000000,
            axisLabel: {
              color: "#ffffff",
              fontSize: 10,
              formatter: function(value) {
                return (value / 10000).toFixed(0) + '万';
              },
            },
            axisLine: {
              lineStyle: {
                color: '#00aaff'
              }
            },
            // 稍微缩小轴的范围
            scale: true
          },
          {
            type: "value",
            name: "利润增长率",
            nameTextStyle: {
              color: "#88ff88",
              fontSize: 12,
              textShadow: '0 0 5px rgba(0,255,128,0.3)'
            },
            splitLine: {
              show: false,
            },
            interval: 10,
            axisLabel: {
              color: "#88ff88",
              fontSize: 10,
              formatter: "{value}%",
            },
            axisLine: {
              lineStyle: {
                color: '#00ff88'
              }
            }
          },
        ],
        series: [
          {
            showAllSymbol: true,
            name: "GDP总值",
            type: "bar",
            barMaxWidth: "40px",  // 稍微缩小柱状图宽度
            label: label(),
            data: totalGDPsInTenThousand,
            itemStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0,
                  color: '#00aaff'
                }, {
                  offset: 1,
                  color: '#0066aa'
                }]
              },
              borderRadius: [3, 3, 0, 0],
              shadowColor: 'rgba(0,170,255,0.5)',
              shadowBlur: 8  // 稍微减小阴影
            }
          },
          {
            name: "GDP增长率",
            type: "line",
            showAllSymbol: true,
            label: label2(),
            yAxisIndex: 1,
            data: resultData.increaseGDPs,
            symbol: 'circle',
            symbolSize: 6,  // 稍微缩小数据点
            lineStyle: {
              color: '#00ff88',
              width: 3,
              shadowColor: 'rgba(0,255,136,0.6)',
              shadowBlur: 12,  // 稍微减小阴影
              shadowOffsetX: 0,
              shadowOffsetY: 2,
              type: 'solid'
            },
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0,
                  color: 'rgba(0,255,136,0.25)'  // 稍微降低透明度
                }, {
                  offset: 1,
                  color: 'rgba(0,255,136,0)'
                }]
              }
            },
            itemStyle: {
              color: '#ffffff',
              borderColor: '#00ff88',
              borderWidth: 2,
              shadowColor: 'rgba(0,255,136,0.6)',
              shadowBlur: 8
            }
          },
        ],
      };

      function label() {
        if (labelTag) {
          return {
            normal: {
              show: true,
              position: "top",
              color: "#ffffff",
              fontSize: 9,  // 稍微缩小字体
              fontWeight: "bold",
              textShadow: '0 0 5px rgba(0,255,255,0.5)',
              formatter: function(params) {
                return (params.value / 10000).toFixed(1) + '万';
              }
            },
          };
        } else {
          return {
            normal: {
              show: false,
            },
          };
        }
      }

      function label2() {
        if (labelTag) {
          return {
            normal: {
              show: true,
              formatter: function (param) {
                return param.value + "%";
              },
              position: "top",
              color: "#88ff88",
              fontSize: 9,  // 稍微缩小字体
              fontWeight: "bold",
              textShadow: '0 0 5px rgba(0,255,128,0.5)'
            },
          };
        } else {
          return {
            normal: {
              show: false,
            },
          };
        }
      }

      function xAxis() {
        return [
          {
            type: "category",
            axisLabel: {
              interval: 0,
              rotate: 30,
              margin: 8,  // 稍微减小边距
              color: "#ffffff",
              fontSize: 9,  // 稍微缩小字体
              textShadow: '0 0 5px rgba(0,255,255,0.2)'
            },
            axisLine: {
              lineStyle: {
                color: '#00aaff'
              }
            },
            axisTick: {
              lineStyle: {
                color: '#00aaff'
              }
            },
            inverse: false,
            data: resultData.times,
          },
        ];
      }




// 初始化图表
      const echartsdom = document.getElementById('mychartF')
      this.mychartsF = echarts.init(echartsdom)
      this.mychartsF.setOption(option, true);// 渲染页面
    },

    initEchartsB() {

      echarts.registerMap('china', chinaGeoJson)

// 数据改为南京和怀柔区
      const pointOption = [
        { name: '南京', value: [118.796, 32.0583] },
        { name: '怀柔区', value: [116.637, 40.316] }  // 怀柔区坐标
      ]

// 财务数据 - 总盈利、总成本、总销售
      const financeList = [
        {
          name: '总盈利',
          value: '1280',
          unit: '万元'
        },
        {
          name: '总成本',
          value: '3560',
          unit: '万元'
        },
        {
          name: '总销售',
          value: '4840',
          unit: '万元'
        }
      ]

// 怀柔区作为终点
      const lastPoint = {
        name: '怀柔区',
        value: [116.637, 40.316],  // 怀柔区坐标
        lineStyle: {
          color: '#FF6C66'
        }
      }

      const colorList = ['#D88BFF', '#5abead', '#66FFFF', '#48D5FF', '#FFE73D', '#66FFFF']

// 只处理两个点的连线
      pointOption.map((item, index) => {
        item.lineStyle = { color: colorList[index % colorList.length] }
        item.coords = [item.value, lastPoint.value]
        return item
      })

// 将终点加入点列表
      pointOption.push(lastPoint)

      const lineOption = pointOption.slice(0, -1)  // 连线数据（不包含最后一个点）

      const option = {
        tooltip: {
          trigger: 'item',
          position: function (point, params, dom, rect, size) {
            var x = 0 // x坐标位置
            var y = 0 // y坐标位置
            // 当前鼠标位置
            var pointX = point[0]
            var pointY = point[1]
            // 提示框大小
            var boxWidth = size.contentSize[0] / 2
            var boxHeight = size.contentSize[1] + 50

            // boxWidth > pointX 说明鼠标左边放不下提示框
            if (boxWidth > pointX) {
              x = pointX + 10
            } else {
              // 左边放的下
              x = pointX - boxWidth - 10
            }

            // boxHeight > pointY 说明鼠标上边放不下提示框
            if (boxHeight > pointY) {
              y = 5
            } else {
              // 上边放得下
              y = pointY - boxHeight
            }
            return [x, y]
          },
          show: true,
          enterable: true,
          borderWidth: 0,
          textStyle: {
            fontSize: 0,
            color: 'transparent'
          },
          backgroundColor: 'transparent',
          extraCssText: 'box-shadow: 0 0 0 transparent',
          padding: 0,
          triggerOn: 'none',
          formatter: params => {
            const { componentType, data, dataIndex } = params
            if (componentType === 'series' && data) {
              // 根据不同的城市显示不同的数据
              const cityName = data.name
              let cityData

              if (cityName === '南京') {
                cityData = {
                  profit: '2560',  // 南京总盈利
                  cost: '4120',    // 南京总成本
                  sales: '6680'     // 南京总销售
                }
              } else if (cityName === '怀柔区') {
                cityData = {
                  profit: '1280',  // 怀柔区总盈利
                  cost: '3560',    // 怀柔区总成本
                  sales: '4840'     // 怀柔区总销售
                }
              } else {
                cityData = {
                  profit: '1920',
                  cost: '3840',
                  sales: '5760'
                }
              }

              let tipHtml = '<div class="tipHtml" style="width:220px;height:150px;background:url(https://img.isqqw.com/profile/upload/2025/03/11/b755154a-eb2b-4ed3-962b-fa27e35da717.png) no-repeat left top;background-size:100% 100%;color:#fff;">'
              tipHtml += `<h3 class="tipHtml-title" style="height: 35px;
  padding: 12px 0;
  font-weight: bold;
  font-size: 18px;
  color: #19ecff;
  line-height: 15px;
  text-align: center;">${cityName}</h3>`
              tipHtml += `<div class="tipHtml-bottom" style="display:flex;
  justify-content: space-between;
  padding: 0 15px 15px;">`

              // 显示三个财务指标：总盈利、总成本、总销售
              const financeItems = [
                { name: '总盈利', value: cityData.profit, color: '#66ff66' },
                { name: '总成本', value: cityData.cost, color: '#ff6666' },
                { name: '总销售', value: cityData.sales, color: '#66ffff' }
              ]

              for (let i = 0; i < financeItems.length; i++) {
                const item = financeItems[i]
                tipHtml += `<div class="tipHtml-bottom-item" style="width:60px;
  height: 35px;">
          <div class="tipHtml-bottom-item-value" style="display: flex;
  justify-content: center;
  align-items: baseline;">
            <span style="height: 25px;
    font-weight: bold;
    font-size: 16px;
    color: ${item.color};
    line-height: 25px;
    text-align: center;">${item.value}</span>
            <span style=" font-size: 12px;
    color: ${item.color};
    line-height: 25px;
    margin-left: 2px;">万</span>
          </div>
          <div class="tipHtml-bottom-item-label" style="height: 25px;
  font-size: 12px;
  color: #ffffff;
  line-height: 25px;
  text-align: center;">${item.name}</div>
        </div>`
              }

              tipHtml += `<img class="tipHtml-icon" src="https://img.isqqw.com/profile/upload/2025/03/11/413a9c9c-52d4-468f-b11d-4818e27f7660.png" style=" position: absolute;
  bottom: -35px;
  left: 50%;
  width: 21px;
  height: 24px;
  animation: jumpBoxHandler 1.8s infinite;">`
              tipHtml += '</div>'
              return tipHtml
            }
          }
        },
        geo: [
          {
            map: 'china',
            zoom: 1,
            z: 70,
            top: '70px',
            selected: false,
            label: {
              show: false,
              padding: 4,
              color: '#ddd',
              fontFamily: 'pf-zh'
            },
            itemStyle: {
              areaColor: {
                repeat: 'repeat'
              },
              borderColor: 'rgba(147,234,245,.5)',
              borderWidth: 1
            },
            emphasis: {
              disabled: true
            },
            regions: [
              {
                name: '南海诸岛',
                emphasis: {
                  disabled: true
                },
                itemStyle: {
                  borderWidth: 1
                }
              }
            ]
          },
          {
            type: 'map',
            map: 'china',
            zoom: 1,
            z: 60,
            top: '70px',
            selected: false,
            itemStyle: {
              areaColor: '#177db7'
            },
            emphasis: {
              disabled: true
            },
            regions: [
              {
                name: '南海诸岛',
                emphasis: {
                  disabled: true
                },
                itemStyle: {
                  areaColor: 'transparent',
                  borderWidth: 0
                }
              }
            ]
          }
        ],
        series: [
          // 水波圈效果
          {
            type: 'effectScatter',
            coordinateSystem: 'geo',
            showEffectOn: 'render',
            z: 90,
            rippleEffect: {
              period: 12,
              scale: 4,
              brushType: 'fill'
            },
            label: {
              formatter: '{b}',
              position: 'top',
              offset: [0, -10],
              color: '#1DE9B6',
              show: true,
              fontSize: 12
            },
            itemStyle: {
              color: value => {
                return value.data.lineStyle ? value.data.lineStyle.color : '#5abead'
              },
              shadowBlur: 10,
              shadowColor: '#333'
            },
            symbolSize: 12,  // 稍微放大点，更明显
            data: pointOption
          }
          // 流转线效果 - 已注释掉
          /*
          {
             type: 'lines',
             z: 100,
             effect: {
                show: true,
                period: 8,
                trailLength: 0.4,
                symbol: 'arrow',
                symbolSize: 5
             },
             lineStyle: {
                color: '#1DE9B6',
                width: 2,
                opacity: 0.3,
                curveness: 0.3
             },
             data: lineOption
          }
          */
        ]
      }

// 定义只在两个数据点（南京和怀柔区）之间循环的索引
      let dataPointIndex = 0
// 定义数据点的数量（不包括作为终点的lastPoint）
      const dataPointCount = pointOption.length - 1 // pointOption长度为3，减1后为2

// 显示指定索引的提示框


// 初始化时立即显示南京的提示框
      setTimeout(() => {
        this.showTooltipByIndex(0)
      }, 100) // 给图表一点渲染时间

// 循环显示函数
      const onHighlight = () => {
        return setInterval(() => {
          // 在 0 和 1 之间切换
          dataPointIndex = (dataPointIndex + 1) % dataPointCount
          this.showTooltipByIndex(dataPointIndex)
        }, 3000) // 3秒切换一次
      }

// 启动循环
      let timer = onHighlight()




// 可选：鼠标移出时立即切换到下一个点（如果需要更流畅的体验）
// 如果不希望移出后立即切换，可以使用上面的版本

      function loadCssCode(code) {
        var style = document.createElement('style')
        style.type = 'text/css'
        style.rel = 'stylesheet'
        try {
          style.appendChild(document.createTextNode(code))
        } catch (ex) {
          style.styleSheet.cssText = code
        }
        var head = document.getElementsByTagName('head')[0]
        head.appendChild(style)
      }
      loadCssCode('@keyframes jumpBoxHandler {0% {transform: translate(0px, 0px);} 50% {transform: translate(0px, 20px);} 100% {transform: translate(0px, 0px);}}')
      const echartsdom = document.getElementById('mychartB')

      this.mychartsB = echarts.init(echartsdom)
      this.mychartsB.setOption(option, true);// 渲染页面


      // 鼠标悬停时：显示对应点的提示框并暂停循环
      this.mychartsB.on('mouseover', (params) => {
        // 清除循环
        if (timer) {
          clearInterval(timer)
          timer = null
        }

        // 如果悬停在水波圈上，立即显示对应的提示框
        if (params.componentType === 'series' && params.seriesType === 'effectScatter') {
          this.showTooltipByIndex(params.dataIndex)
        }
      })

      // 鼠标移出时：重新启动循环
      this.mychartsB.on('mouseout', (params) => {
        // 如果已经有timer在运行，先清除
        if (timer) {
          clearInterval(timer)
        }
        // 重新启动循环，从当前显示的点开始
        timer = onHighlight()
      })



    },
    showTooltipByIndex(index){
        this.mychartsB.dispatchAction({
          type: 'showTip',
          seriesIndex: 0, // 水波圈系列的索引
          dataIndex: index
        })

    },
    checkPrower(permission) {
      const qx = localStorage.getItem('qx');
      return qx && qx.includes(permission);
    },
    openDialog() {
      this.$emit("bigshowptjs", false)
    },
    handleBack() {
      this.$emit("bigshowptjs", true)
    },
    closeDialog() {

    },
    getList() {
      this.loading = true;
      this.$request.postHttp({
        url: "/basic/ProductList",
        data: JSON.stringify(this.queryParams),
        success: (data) => {
          this.tableData = data.data.records
          this.total = data.data.total
        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
      this.loading = false;
    },


  },
}
</script>
<style scoped>
.dashboard {
  height: 100vh;
  width: 100vw;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  overflow: hidden;
}

.dashboard::after {
  content: '';
  position: absolute;
  inset: 0;
  background: rgba(10, 15, 35, 0.65);
  z-index: 0;
}

.grid-container {
  position: relative;
  z-index: 1;
  height: 100%;
  width: 100%;
  display: grid;
  grid-template-rows: 1fr 3fr 3fr 3fr;
  grid-template-columns: 3fr 4fr 3fr;
  gap: 10px;
  padding: 10px;
  box-sizing: border-box;
}

.grid-item {
  background: rgba(30, 40, 70, 0.6);
  border-radius: 12px;
  border: 1px solid rgba(100, 120, 255, 0.25);
  color: #e0e0ff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
}

/* Header 专用样式 */
.header-content {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.title {
  font-size: 38px;
  margin: 0;
  text-align: center;
  flex: 1;
}

.header-icons {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  gap: 16px;
}

.icon-btn {
  background: rgba(80, 100, 180, 0.5);
  border: 1px solid rgba(140, 160, 255, 0.4);
  border-radius: 8px;
  color: #d0e0ff;
  font-size: 24px;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
}

.icon-btn:hover {
  background: rgba(100, 130, 220, 0.7);
  transform: scale(1.08);
}

/* Dialog 样式 */
.dialog-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.65);
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dialog-content {
  background: rgba(30, 40, 80, 0.95);
  border-radius: 12px;
  padding: 28px 36px;
  width: 90%;
  max-width: 460px;
  border: 1px solid rgba(120, 150, 255, 0.4);
  color: #e0e0ff;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
}

.dialog-content h3 {
  margin: 0 0 16px 0;
  font-size: 1.5rem;
}

.dialog-actions {
  margin-top: 24px;
  display: flex;
  gap: 16px;
  justify-content: flex-end;
}

.dialog-actions button {
  padding: 8px 20px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
}

.dialog-actions button:first-child {
  background: #444;
  color: white;
}

.dialog-actions button:last-child {
  background: #5a7cff;
  color: white;
}
</style>